import { render } from "./VocabularyTestResult.vue?vue&type=template&id=793acc6a&scoped=true"
import script from "./VocabularyTestResult.vue?vue&type=script&lang=js"
export * from "./VocabularyTestResult.vue?vue&type=script&lang=js"

import "./VocabularyTestResult.vue?vue&type=style&index=0&id=793acc6a&scoped=true&lang=less"

import exportComponent from "../../../node_modules/.store/vue-loader@17.4.2/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-793acc6a"]])

export default __exports__